<template>
  <div class="search">
    <van-search
      v-model="value"
      placeholder="请输入搜索关键词"
      show-action
      autofocus
      @search="onSearch"
    >
      <div slot="action" @click="onSearch">搜索</div>
    </van-search>

    <van-list
        v-model="loading"
        finished-text="没有更多了"
        :finished="finished"
        :immediate-check="false"
        @load="onLoad"
      >
      <clazz-panel v-for="(item, index) in list" :key="index" :clazz="item" />
    </van-list>

  </div>
</template>

<script>
import { Search, List } from 'vant'
import ClazzPanel from './components/ClazzPanel'
import { clazzList } from '@/api/clazz'

export default {
  name: 'search',
  components: {
    [Search.name]: Search,
    [List.name]: List,
    ClazzPanel
  },
  data () {
    return {
      value: '',
      list: [],
      loading: false,
      finished: false,
      listQuery: {
        clazz_name: '',
        page: 0,
        size: 8
      }
    }
  },
  methods: {
    onSearch () {
      if (!this.value) {
        return false
      }
      this.listQuery.clazz_name = this.value
      this.listQuery.page = 1
      this.list = []
      this.finished = false
      this.getList()
    },
    async getList () {
      this.loading = true
      let response = await clazzList(this.listQuery)
      this.loading = false
      this.pullLoading = false
      this.list = this.list.concat(response.data.results)
      this.checkFinished(response.data.count)
    },
    onLoad () {
      this.listQuery.page += 1
      this.getList()
    },
    checkFinished (total) {
      this.finished = this.list.length >= total
    }
  }
}
</script>

<style scoped lang="scss">
</style>
